module.exports = __webpack_public_path__ + "img/47.03bbc950.jpg";